import { PersonalInsurancePremiumResponse } from '@app/domain/model/eshop/personal-accidents/PersonalInsurancePremiumResponse';
import { ChangeEvent, useCallback, useMemo, useState } from 'react';

export function usePriceCalculation(currentPremiums: Nullable<PersonalInsurancePremiumResponse>) {
    const [selectedRiskCode, setSelectedRiskCode] = useState<string>('');

    const selectedRisk = useMemo(() => {
        if (!currentPremiums || !selectedRiskCode) return undefined;

        return currentPremiums.riskPackages.find(risk => risk.code === selectedRiskCode);
    }, [currentPremiums, selectedRiskCode]);

    const totalPrice = useMemo(() => {
        if (!selectedRisk) return 0;

        return selectedRisk.premiumAfterDiscount && selectedRisk.premiumAfterDiscount > 0
            ? selectedRisk.premiumAfterDiscount
            : selectedRisk.premium || 0;
    }, [selectedRisk]);

    const priceToPayNow = useMemo(() => {
        if (
            !currentPremiums?.paymentSchedule ||
            currentPremiums.paymentSchedule.length === 0 ||
            currentPremiums.riskPackages.length > 1
        ) {
            return totalPrice;
        }

        const firstPaymentAmount =
            currentPremiums?.paymentSchedule.length > 0 ? currentPremiums.paymentSchedule[0].amountAfterDiscount : 0;

        return firstPaymentAmount;
    }, [currentPremiums?.paymentSchedule, currentPremiums?.riskPackages.length, totalPrice]);

    const handleRisksChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;

        setSelectedRiskCode(value);
    }, []);

    const initializeFromSession = useCallback((riskCode: string) => {
        setSelectedRiskCode(riskCode);
    }, []);

    return {
        priceState: {
            selectedRisk,
            selectedRiskCode,
            totalPrice,
            priceToPayNow,
        },
        handleRisksChange,
        initializeFromSession,
    };
}
